<template>

    <div class="trax-struct-map trax-struct-flat" v-show="loaded">
        <div :id="id+'-struct'" class="trax-struct-body">

            <button class="btn btn-secondary btn-sm mb-4" v-for="(action, index) in timeModeOptions" :key="index"
                    :class="action.color ? 'text-'+action.color : 'text-'+headerColor" :id="action.event" @click="switchTimeMode"
            >
                <span v-if="action.name">{{ action.name }}</span>
            </button>

            <div v-if="timeMode">
                <div class="trax-block trax-level-1">

                    <div class="trax-block-body">

                        <div class="card" v-for="learning_unit in timeSortedLearningUnits" :key="learning_unit.id">

                            <div class="card-body">

                                <enac-atpl-dashboard-phase-map-item
                                    :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                                >
                                </enac-atpl-dashboard-phase-map-item>

                                <div class="row">
                                    <div class="col-xl-7 trax-name">
                                        <h4>{{ learning_unit.name }}</h4>
                                        <div class="mt-2" v-html="flightInfo(learning_unit)"></div>
                                    </div>
                                    <div class="col-xl-5" v-html="itemStatus(learning_unit)"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else>

                <div class="trax-block trax-level-1" v-for="section in sections" :key="section.id" :data-id="section.id"
                    v-if="section.learning_units && section.learning_units.length > 0">

                    <h3 v-if="sections.length>1">{{ section.name }}</h3>

                    <div class="clearfix"></div>

                    <div :id="id+'-struct-'+section.id" class="trax-block-body" :data-id="section.id">

                        <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="programUnit(learning_unit)">

                            <div class="card-body">

                                <enac-atpl-dashboard-phase-map-item
                                    :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                                >
                                </enac-atpl-dashboard-phase-map-item>

                                <div class="row">
                                    <div class="col-xl-7 trax-name">
                                        <h4>{{ learning_unit.name }}</h4>
                                        <div class="mt-2" v-html="flightInfo(learning_unit)"></div>
                                    </div>
                                    <div class="col-xl-5" v-html="itemStatus(learning_unit)"></div>
                                </div>
                            </div>
                        </div>

                        <div class="trax-btn-square trax-icon" v-if="hasGroupUnits(section)">
                            + <i class="material-icons">people_outline</i>
                        </div>

                        <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="groupUnit(learning_unit)">

                            <div class="card-body">

                                <enac-atpl-dashboard-phase-map-item
                                    :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                                >
                                </enac-atpl-dashboard-phase-map-item>

                                <div class="row">
                                    <div class="col-xl-7 trax-name">
                                        <h4>{{ learning_unit.name }}</h4>
                                        <div class="mt-2" v-html="flightInfo(learning_unit)"></div>
                                    </div>
                                    <div class="col-xl-5" v-html="itemStatus(learning_unit)"></div>
                                </div>
                            </div>
                        </div>

                        <div class="trax-btn-square trax-icon" v-if="hasUserUnits(section)">
                            + <i class="material-icons">person_outline</i>
                        </div>

                        <div class="card" v-for="learning_unit in section.learning_units" :key="learning_unit.id" v-if="userUnit(learning_unit)">

                            <div class="card-body">

                                <enac-atpl-dashboard-phase-map-item
                                    :id="id" :bus="bus" :item="learning_unit" :states="states" :individual="true"
                                >
                                </enac-atpl-dashboard-phase-map-item>

                                <div class="row">
                                    <div class="col-xl-7 trax-name">
                                        <h4>{{ learning_unit.name }}</h4>
                                        <div class="mt-2" v-html="flightInfo(learning_unit)"></div>
                                    </div>
                                    <div class="col-xl-5" v-html="itemStatus(learning_unit)"></div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
    export default {

        props: {
            id: null,
            bus: null
        },

        data: function() {
            return {
                lang: lang,
                loaded: false,
                user: user,
                learner: data.learner,
                registration: data.registration,
                learning_unit_dashboard_routes: data.learning_unit_dashboard_routes,
                locations_names_uuid: data.locations_names_uuid,
                aircraft_types_names: data.aircraft_types_names,
                aircraft_categories_names: data.aircraft_categories_names,
                endpoint: app_url+'polaris/api/front/dashboard/registrations/'+data.registration.id+'/phases/'+data.phase.id+'/learners/'+data.learner.id+'/with-program',
                url_base: app_url+'polaris/ui/atpl-dashboard/registration/'+data.registration.id+'/',
                sections: [],
                linearUnits : [],
                states : {},
                timeMode: false,
            }
        },

        created: function() {
            this.getDataWithStates();
        },

        computed: {

            collectiveDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.read-all'] || this.user.permissions['dashboard.read-mine-locations']
                    || this.user.permissions['dashboard.read-mine-collaborators'] || this.user.permissions['dashboard.write-all']
                    || this.user.permissions['dashboard.write-mine-locations'] || this.user.permissions['registration.manage'];
            },

            editDashboardPermission() {
                return this.user.admin || this.user.permissions['dashboard.write-all'] || this.user.permissions['dashboard.write-mine-locations'];
            },

            editDashboardStatus() {
                return this.registration.status != 'draft' && this.registration.status != 'archived';
            },

            timeModeOptions() {
                return [
                    {
                        name: this.timeMode ? 'Switch to modules view' : 'Switch to time view',
                        color: 'default',
                        event: 'switch-mode' 
                    }
                ]
            },

            timeSortedLearningUnits() {
                return this.linearUnits.sort((a, b) => {
                    var stateA = this.states[a.id]
                    var stateB = this.states[b.id]
                    if (!stateA && !stateB) {
                        return 0
                    }
                    if (!stateA && stateB) {
                        return 1
                    }
                    if (stateA && !stateB) {
                        return -1
                    }
                    if (!stateA.date) {
                        return 1
                    }
                    if (!stateB.date) {
                        return -1
                    }
                    if (stateA.date == stateB.date) {
                        return 0
                    }
                    return stateA.date > stateB.date ? 1 : -1
                })
            }
        },

        methods: {

            switchTimeMode() {
                this.timeMode = !this.timeMode
            },

            programUnit(learning_unit) {
                return !learning_unit.registration_id;
            },

            groupUnit(learning_unit) {
                return learning_unit.registration_id && !learning_unit.user_id;
            },

            userUnit(learning_unit) {
                return learning_unit.user_id;
            },

            initLinearUnits() {
                this.linearUnits = []
                for (var index in this.sections) {
                    var section = this.sections[index]
                    var programUnits = section.learning_units.filter(unit => this.programUnit(unit))
                    var groupUnits = section.learning_units.filter(unit => this.groupUnit(unit))
                    var userUnits = section.learning_units.filter(unit => this.userUnit(unit))
                    this.linearUnits = [...this.linearUnits, ...programUnits, ...groupUnits, ...userUnits]
                }
            },

            hasGroupUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.groupUnit(learning_unit)) return true;
                }
                return false;
            },

            hasUserUnits(section) {
                for (var index in section.learning_units) {
                    var learning_unit = section.learning_units[index];
                    if (this.userUnit(learning_unit)) return true;
                }
                return false;
            },

            getDataWithStates() {
                axios.get(this.endpoint)
                    .then(response => {
                        this.states = Array.isArray(response.data.data) ? {} : response.data.data
                        this.sections = response.data.included.sections;
                        this.initLinearUnits()
                        this.loaded = true;
                    })
                    .catch(error => {
                    });
            },

            flightInfo(learning_unit) {
                var flightSessions = ['enac-atpl-flight-session', 'enac-atpl-simu-session'];
                if (flightSessions.indexOf(learning_unit.type) == -1) return;
                var state = this.states[learning_unit.id];
                var html = '';

                // Aircraft type
                if (state && state.aircraft_type) {
                    html += '<p class="mb-1"><strong>';
                    html += '<i class="material-icons" style="transform: rotate(0.25turn)">flight</i>';
                    html += this.lang.polaris.common.aircraft_type;
                    html += ': </strong>';
                    html += this.aircraft_types_names[state.aircraft_type];
                    html += '</p>';
                }

                // Aircraft category
                if (state && state.aircraft_category) {
                    html += '<p class="mb-1"><strong>';
                    html += '<i class="material-icons" style="transform: rotate(0.25turn)">flight</i>';
                    html += this.lang.polaris.common.aircraft_category;
                    html += ': </strong>';
                    html += this.aircraft_categories_names[state.aircraft_category];
                    html += '</p>';
                }

                // Flight time
                if (state && state.duration) {
                    html += '<p class="mb-1"><strong>';
                    html += '<i class="material-icons">query_builder</i>';
                    html += this.lang.polaris.dashboard.flight_time;
                    html += ': </strong>';
                    html += state.duration;
                    html += '</p>';
                }

                // TAG Landing
                if (state && state.tag_landing) {
                    html += '<p class="mb-1"><strong>';
                    html += '<i class="material-icons">flight_land</i>';
                    html += this.lang.polaris.dashboard.tag_landing;
                    html += ': </strong>';
                    html += state.tag_landing;
                    html += '</p>';
                }

                return html;
            },

            description(learning_unit) {
                var res = '';
                if (learning_unit.meta.assessment) {
                    res = '<strong>' + this.lang.polaris.dashboard.progress_check + '</strong>';
                    if (learning_unit.description) res += ' - ';
                }
                if (!learning_unit.description) return res;
                var description = learning_unit.description.length < 150 
                    ? learning_unit.description 
                    : learning_unit.description.substring(0, 144) + ' (...)';
                return res + description;
            },

            itemStatus(learning_unit) {

                if (!learning_unit.conditions.lrConditionSatisfied) {
                    var html = '<h6 class="text-left text-danger">';
                    html += 'Some level reports have not been completed before this session!';
                    html += '</h6>';
                    return html;
                }

                if (!this.states[learning_unit.id]) return this.itemAction(learning_unit, false);
                var state = this.states[learning_unit.id];
                var html = '';

                //Status.
                html += this.formatStatus(this.statusLabel(learning_unit, state), state.color_status, state.grade, state.grade_max);

                // Date.
                if (state.date) {
                    html += '<h6 class="mb-1"><i class="material-icons">event</i> ' + moment(state.date).format('DD MMM YYYY') + '</h6>';
                }

                // Location.
                if (state.location) {
                    var name = this.locations_names_uuid[state.location.entity_uuid];
                    if (!name) name = state.location.entity_name;
                    html += '<h6 class="mb-1"><i class="material-icons">location_on</i> '+name+'</h6>';
                }

                // Author.
                if (state.validation || (state.author && state.author.user_uuid)) {
                    var author = state.validation ? state.validation : state.author
                    html += '<h6 class="mb-1"><i class="material-icons">edit</i> '+author.user_name+'</h6>';
                }

                // Buttons.
                html += this.itemAction(learning_unit, state);

                return html;
            },

            itemAction(learning_unit, state) {
                var html = '';
                var view = this.viewAllowed(learning_unit, state);
                var edit = this.editAllowed(learning_unit, state);
                if (view || edit) {
                    html += '<div>';

                    // View button.
                    if (view) {
                        html += '<a href="' + this.viewLink(learning_unit) + '" class="btn btn-sm btn-default">';
                        html += this.lang.polaris.dashboard.details;
                        html += '</a>';
                    }
                    
                    // Edit button.
                    if (edit) {
                        html += '<a href="' + this.editLink(learning_unit) + '" class="btn btn-sm btn-primary">';
                        html += this.lang.polaris.dashboard.edit;
                        html += '</a>';
                    }
                    
                    html += '</div>';
                }
                return html;
            },

            statusLabel(learning_unit, state) {
                if (state.partially_passed) {
                    return this.lang.polaris.dashboard.partial_pass;
                } else if (state.passed != undefined) {
                    if (learning_unit.type == 'enac-atpl-level-report') {
                        return state.passed ? this.lang.polaris.dashboard.satisfactory : this.lang.polaris.dashboard.unsatisfactory;
                    } else {
                        return state.passed ? this.lang.polaris.dashboard.pass : this.lang.polaris.dashboard.fail;
                    }
                } else if (state && state.completed) {
                    if (learning_unit.type == 'enac-atpl-level-report') {
                        return '';
                    } else if (learning_unit.type == 'enac-atpl-course-session') {
                        return this.lang.polaris.dashboard.attended;
                    } else {
                        return this.lang.polaris.dashboard.completed;
                    }
                }
            },
        
            formatStatus(text, color, grade, grade_max) {
                if (grade != undefined) {
                    var html = '<h4 class="text-'+color+' font-weight-bold text-uppercase mb-1">';
                    html += grade;
                    if (grade_max != undefined) html += '/'+grade_max;
                    html += '</h4>';
                } else {
                    var html = '<h4 class="text-'+color+' font-weight-bold text-uppercase mb-1">';
                    html += text;
                    html += '</h4>';
                }
                return html;
            },

            viewAllowed(learning_unit, state) {
                if (learning_unit.type == 'enac-atpl-self-paced') return true;
                if (!this.viewEnabled(state)) return false;
                return true;
            },
        
            editAllowed(learning_unit, state) {
                if (learning_unit.type == 'enac-atpl-self-paced') return false;
                return !this.viewEnabled(state) && this.editDashboardPermission && this.editDashboardStatus;
            },
        
            viewEnabled(state) {
                return state && state.validation;
            },
        
            viewLink(learning_unit) {
                var routes = this.learning_unit_dashboard_routes;
                var href = routes[learning_unit.type]+'/registration/'+this.registration.id+'/'+learning_unit.type+'/'+learning_unit.id;
                if (this.learner) {
                    href += '/learner/'+this.learner.id;
                }
                return href;
            },
        
            editLink(learning_unit) {
                return this.viewLink(learning_unit) + '/edit';
            }
        
        }
    }
</script>
